
/**
 * 讲师
 */

 export const TeacherList=[
    {
        prop:"id",
        label:"id",
        width:"150",
        format: "",
        order: false,
        isShow:false
    },
    {
        prop:"name",
        label:"姓名",
        width:"150",
        format: "",
        order: false,
        isShow:true
    },
    {
        prop:"englishName",
        label:"英文名",
        width:"150",
        format: "",
        order: false,
        isShow:true
    },
    {
        prop:"level",
        label:"等级",
        width:"150",
        format: "level",
        order: false,
        isShow:true
    },
    // {
    //     prop:"imgUrl",
    //     label:"头像",
    //     width:"150",
    //     format: "imgUrl",
    //     order: false,
    //     isShow:true
    // },
    {
        prop:"isTopTeacher",
        label:"是否名师",
        width:"150",
        format: "isTopTeacher",
        order: false,
        isShow:true
    },
    {
        prop: "creationTime",
        label: "创建时间",
        width: "200",
        format: "datetime",
        order: true,
        isShow: true
    }
 ]

